import { render, staticRenderFns } from "./bo-login-popup.vue?vue&type=template&id=054976c0"
import script from "./bo-login-popup.vue?vue&type=script&lang=js"
export * from "./bo-login-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports